module.exports = "../../../../platform/assets/pageMainIcon/industry_baobiaochaxunlei8.svg";